function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.5 19.800781 L 70.199219 4.5 L 85.5 70.199219 L 19.800781 85.5 Z M 8.910156 22.589844 L 67.410156 8.910156 L 81.089844 67.410156 L 22.589844 81.089844 Z M 60.75 59.578125 L 38.25 64.800781 L 29.25 26.28125 L 37.800781 24.300781 L 45.269531 56.070312 L 59.128906 52.828125 Z M 60.75 59.578125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPlate);
export default __webpack_public_path__ + "static/media/L-plate.3f161d00f6ddbf1a3c8af1b3abaaaf80.svg";
export { ForwardRef as ReactComponent };